import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import { getSubscription } from "../api/getSubscription";

/** Current subscription status (drives Settings → Billing). */
export function useSubscription() {
  return useQuery({
    queryKey: queryKeys.billing.subscription(),
    queryFn: getSubscription,
    staleTime: 60_000,
  });
}
